import { format } from 'date-fns';

const dateOnly = (value, def = '') => {
  if (!value) {
    return def || '';
  }
  const myDate = typeof value === 'string' ? new Date(value) : value;
  return `${format(myDate, 'MM/dd/yyyy')}`;
};

export default dateOnly;
